export enum CoinFilterType {
  SHOW_ALL = null,
  COINS = 0,
  RECOGNITION = 1,
  MILESTONE_REACHED = 2,
}
